import store from "../store/store";
import Liveness2D from "./liveness/Liveness2D";
import LivenessFacetec from "./liveness/LivenessFacetec";
import LivenessSerasa from "./liveness/LivenessSerasa";
import LivessCaf from './liveness/LivenessCaf';

export default class LivenessService{

    constructor() {
        this.$store = store;
    }

    getLiveness(){
        if(!this.liveness){
            this.liveness = this.loadLiveness();
        }
        return this.liveness;
    }

    carregar(reload= false){
        let id = this.getLiveness().gerarID();
        if(document.getElementById(id)){
            return new Promise(resolve => resolve());
        }
        return this.getLiveness().carregarArquivos(id)
            .then(() => this.preLoad(reload));
    }

    preLoad(reload = false){
        if(typeof window.SDK  === 'undefined'){
            window.SDK = window.BrScanSDKSelfie;
        }
        let componente_nao_carregado = (typeof window.selfie  !== 'object' || !(window.selfie instanceof window.SDK.Selfie));
        if(componente_nao_carregado || reload){
            this.getLiveness().preLoad();
            this.$store.dispatch('definirComponenteSelfieCarregado',true);
        }
    }

    loadLiveness(){
        switch (parseInt(this.$store.state.liveness)){
            case 1:
                return new Liveness2D();
            case 2:
                return new LivenessFacetec();
            case 3:
                return new LivenessSerasa();
            case 4:
                return new LivessCaf();
        }
    }

    getRouteName(){
        return this.getLiveness().getRouteName();
    }


}



// WEBPACK FOOTER //
// ./src/services/LivenessService.js